import { handleActions } from "redux-actions";
import createPromiseThunk from "lib/createPromiseThunk";
import * as api from "lib/api/history";

// 자원 내역
const HISTORY_LOAD = "history/HISTORY_LOAD";
const HISTORY_LOAD_PENDING = "history/HISTORY_LOAD_PENDING";
const HISTORY_LOAD_SUCCESS = "history/HISTORY_LOAD_SUCCESS";

export const historyData = createPromiseThunk(HISTORY_LOAD, api.history);

const initialState = {
  data: null,
  user: null
};

export default handleActions(
  {
    [HISTORY_LOAD_PENDING]: (state, { payload }) => ({
      ...state,
      data: null,
      user: null
    }),
    [HISTORY_LOAD_SUCCESS]: (state, { payload }) => ({
      ...state,
      data: payload.data.dataList,
      user: payload.data.user
    })
  },
  initialState
);
